var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 19 19" }, props),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M9.5 18.9c-2.5 0-4.8-1-6.5-2.7S.3 12.1.3 9.7c0-2.5 1-4.8 2.7-6.5.5-.7 1.5-.7 2.1-.1s.6 1.5 0 2.1C3.9 6.4 3.3 8 3.3 9.6c0 1.7.7 3.2 1.8 4.4 1.2 1.2 2.8 1.8 4.4 1.8s3.2-.7 4.4-1.8c1.2-1.2 1.8-2.8 1.8-4.4 0-1.7-.7-3.2-1.8-4.4-.6-.6-.6-1.5 0-2.1s1.5-.6 2.1 0c1.7 1.7 2.7 4.1 2.7 6.5 0 2.5-1 4.8-2.7 6.5-1.7 1.8-4 2.8-6.5 2.8z" }),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M9.5 11.1c-.8 0-1.5-.7-1.5-1.5v-8C8 .8 8.7.1 9.5.1S11 .8 11 1.6v8c0 .9-.7 1.5-1.5 1.5z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Logout.svg